"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _compile = _interopRequireDefault(require("../appSet/components/compile.vue"));
var _certificate = _interopRequireDefault(require("../appSet/components/certificate.vue"));
var _pictures = _interopRequireDefault(require("../appSet/components/pictures.vue"));
var _storyBoard = _interopRequireDefault(require("../appSet/components/storyBoard.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  components: {
    pictures: _pictures.default,
    storyBoard: _storyBoard.default,
    certificate: _certificate.default,
    compile: _compile.default
  },
  data: function data() {
    return {
      tabList: [{
        name: 'app图标',
        id: 0
      }, {
        name: '启动图',
        id: 1
      }, {
        name: '证书&安全图片',
        id: 2
      }, {
        name: '云打包',
        id: 3
      }],
      activeNum: 0,
      settings: {},
      androidPackageName: '',
      iosPackageName: '',
      statusObj: {
        0: '待调度 ',
        1: '进行中',
        2: '处理完成',
        3: '处理失败'
      },
      packageUrl: '',
      packageStatus: ''
    };
  },
  mounted: function mounted() {},
  methods: {
    changeType: function changeType(val) {
      this.activeNum = val;
    }
  }
};